import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Container from './Container';

const StyledContainer = styled(Container)`
  background-color: ${props =>
    props.theme.background[props.backgroundColor] ||
    props.backgroundColor ||
    props.theme.background.background700};
`;

const Placeholder = ({ children, ...props }) => (
  <StyledContainer {...props}>{children}</StyledContainer>
);

Placeholder.propTypes = {
  children: PropTypes.node,
};

Placeholder.defaultProps = {
  children: null,
};

export default Placeholder;
